import { makeStyles } from '@material-ui/core/styles';

const useStyle = makeStyles(() => ({
  inputIcon: {
    fontSize: '1.2rem',
    color: '#6c687d',
    textAlign: 'center',
  },
}));

export default useStyle;
